import { render, staticRenderFns } from "./BaseSlideUpDown.vue?vue&type=template&id=5428eca2&scoped=true&"
import script from "./BaseSlideUpDown.vue?vue&type=script&lang=js&"
export * from "./BaseSlideUpDown.vue?vue&type=script&lang=js&"
import style0 from "./BaseSlideUpDown.vue?vue&type=style&index=0&id=5428eca2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428eca2",
  null
  
)

export default component.exports